import { render } from "./ActionSection.vue?vue&type=template&id=1016a66a"
import script from "./ActionSection.vue?vue&type=script&lang=js"
export * from "./ActionSection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1016a66a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1016a66a', script)) {
    api.reload('1016a66a', script)
  }
  
  module.hot.accept("./ActionSection.vue?vue&type=template&id=1016a66a", () => {
    api.rerender('1016a66a', render)
  })

}

script.__file = "resources/js/Jetstream/ActionSection.vue"

export default script